// extracted by mini-css-extract-plugin
export var brandPrimary = "index-module--brandPrimary--0f1db";
export var critical = "index-module--critical--0a209";
export var notification = "index-module--notification--0b9fd";